import smartlookClient from 'smartlook-client';

export const sendEventToSmartLook = (eventName, dataProperties) => {
  const properties = { type: dataProperties };
  smartlookClient.track(eventName, properties);
};
